import { CSSProperties, PropsWithChildren } from 'react'
import clsx from 'clsx'
import { BADGE_COLOR, BADGE_OUTLINE_ALPHA, TBadgeColorKey } from '../../const/badge-color.const'
import styles from './Badge.module.scss'

export type TBadgeSize = 'sm' | 'md'
export type TBadgeVariant = 'fill' | 'outline' | 'light'

export interface BadgeProps extends PropsWithChildren {
  color?: TBadgeColorKey
  size?: TBadgeSize
  variant?: TBadgeVariant
  value?: string
}

export const Badge = ({
  color = 'orange',
  size = 'sm',
  variant = 'outline',
  value,
  children,
}: BadgeProps) => {
  const { color: accent, light } = BADGE_COLOR[color]

  const colors: CSSProperties = {
    color: variant === 'fill' ? 'white' : accent,
    borderColor: accent,
    backgroundColor: {
      fill: accent,
      outline: `${accent}${BADGE_OUTLINE_ALPHA}`,
      light: light ?? `${accent}${BADGE_OUTLINE_ALPHA}`,
    }[variant],
  }

  return (
    <div className={clsx(styles.badge, styles[size], styles[variant])} style={colors}>
      {value ? (
        <span className={styles.content}>{value}</span>
      ) : (
        <div className={styles.content}>{children}</div>
      )}
    </div>
  )
}
